/* eslint-disable */

export const CANCEL_BOT_ORDERS = {
    FETCH_CANCEL_BOT_ORDERS_REQUEST: 'FETCH_CANCEL_BOT_ORDERS_REQUEST',
    FETCH_CANCEL_BOT_ORDERS_SUCCESS: 'FETCH_CANCEL_BOT_ORDERS_SUCCESS',
    FETCH_CANCEL_BOT_ORDERS_FAILURE: 'FETCH_CANCEL_BOT_ORDERS_FAILURE',
};
